/* 전체 지역 리스트 */
const url = "/monitor/userStat/devsInfo";

export const getDevsInfo = async (conn, dataState) => {
  const { take, skip, userTerm, cid, meainStatCode } = dataState;
  const config = {
    params: {
      page: (take + skip) / take,
      size: take,
      cid: cid,
      userTerm: userTerm,
      meainStatCode: meainStatCode,
    },
  };

  const response = await conn.get(url + "/page", config);

  return response;
};
